import { state } from './state.js';

const maskCache = new Map();


export function createMaskGeoJSON(bounds) {
        const key = bounds.join(',');
        if (maskCache.has(key)) return maskCache.get(key); // Return cached version
        

        const [minX, minY, maxX, maxY] = bounds;
        const worldRing = [
            [-180, -85],
            [-180, 85],
            [180, 85],
            [180, -85],
            [-180, -85]
        ];
        const cogRing = [
            [minX, minY],
            [minX, maxY],
            [maxX, maxY],
            [maxX, minY],
            [minX, minY]
        ];

        const geojson = {
            type: "FeatureCollection",
            features: [
                {
                    type: "Feature",
                    properties: { boundsKey: key },
                    geometry: {
                        type: "Polygon",
                        coordinates: [worldRing, cogRing]
                    }
                }
            ]
        };

        maskCache.set(key, geojson);
        return geojson;
    }

export function toggleMaskVisibility(map, sources) {
  state.showMasks = !state.showMasks;
  sources.forEach(source => {
    const maskLayerId = `${source.name}MaskLayer`;
    if (map.getLayer(maskLayerId)) {
        map.setPaintProperty(maskLayerId, 'fill-opacity', state.showMasks ? 0.3 : 0);
    }
  });
  console.log(`Mask visibility: ${state.showMasks ? 'ON' : 'OFF'}`);
}

